module.exports = __webpack_public_path__ + "static/civic-logo-c-invert-562ec4a2204640567b1e0c66d7679ef0.svg";